export default __webpack_public_path__ + "static/media/product.77624364.jpeg";